import { Pipe, PipeTransform } from '@angular/core';
import { formatDate, formatDateTime } from '@wz-utilities/date.utilities';

@Pipe({ name: 'date', standalone: false })
export class DatePipe implements PipeTransform {
  constructor() {}
  transform(date: Date | null, format?: string): string | null {
    return formatDate(date, format);
  }
}

@Pipe({ name: 'dateTime', standalone: false })
export class DateTimePipe implements PipeTransform {
  toDateString() {
    throw new Error('Method not implemented.');
  }
  constructor() {}
  transform(date: Date | undefined): string | null {
    return formatDateTime(date);
  }
}
